/**
 * Заглушки блюда и напитка без фото — как в приложении
 * (edim_app: assets/images/food.svg, drink.svg): серая иконка #C7C7CC на
 * половину квадратного кадра, поля прозрачные.
 */
export const NO_PHOTO = {
  food: 'assets/no-photo-food.svg',
  drink: 'assets/no-photo-drink.svg',
} as const;

export type NoPhotoKind = keyof typeof NO_PHOTO;
